import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  description?: string;
  fullWidth?: boolean;
}
export function Input({
  label,
  error,
  className = '',
  id,
  startContent,
  endContent,
  description,
  fullWidth = true,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-1060">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700" data-id="element-1061">
          {label} {props.required && <span className="text-red-500" data-id="element-1062">*</span>}
        </label>}
      <div className="relative group" data-id="element-1063">
        {startContent && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-1064">
            {startContent}
          </div>}
        <input id={inputId} className={`
            block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 
            ${startContent ? 'pl-10' : 'pl-4'} 
            ${endContent ? 'pr-10' : 'pr-4'} 
            py-2.5 text-sm transition-all duration-200
            placeholder:text-slate-400
            focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
            disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed
            ${error ? 'border-red-300 focus:border-red-500 bg-red-50/10' : 'hover:border-slate-300'}
            ${className}
          `} {...props} data-id="element-1065" />
        {endContent && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-slate-400" data-id="element-1066">
            {endContent}
          </div>}
      </div>
      {description && !error && <p className="text-xs text-slate-500" data-id="element-1067">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium animate-pulse" data-id="element-1068">
          {error}
        </p>}
    </div>;
}